import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import { jsx as _jsx } from "react/jsx-runtime";
const CardText = _ref => {
  let {
    id = '',
    style = {},
    children = [],
    className = '',
    expanded = null,
    expandable = false,
    containerStyle = {}
  } = _ref;
  const cardTextClass = cn('bg-gradient-to-t from-white to-light-border-grey  transition-all duration-150 ease-in-out overflow-hidden', {
    'max-h-0': !expanded && expandable,
    'max-h-80': expanded || !expandable
  }, className);
  const newChildren = filterChildren(children);
  return /*#__PURE__*/_jsx("div", {
    id: id,
    className: cardTextClass,
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: "p-4",
      style: containerStyle,
      children: newChildren
    })
  });
};
CardText.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Override the inline-styles of the contaier element || Not Recommended */
  containerStyle: PropTypes.object,
  /**
   * If true, this card component is controlled.
   * @ignore
   */
  expandable: PropTypes.bool,
  /**
   * If true, this card component is expanded (uncontrolled)
   * @ignore
   */
  expanded: PropTypes.bool,
  /**
  * children props for content inside
  * @ignore
  */
  children: PropTypes.node
};
export default CardText;
//# sourceMappingURL=CardText.js.map